import { displayNameOptions } from "@via/utils/form-validators.tsx";
import { EditDisplayNamePayload } from "@via/utils/interfaces.tsx";
import { type JSX, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { cleanProcessName } from "@via/pages/projects/pipelines/workflow/utils/helpers.tsx";

export default function EditDisplayNameModal({
  data,
  onSubmit,
  onCancel,
}): JSX.Element {
  const [displayName, setDisplayName] = useState("");
  const {
    register,
    handleSubmit,
    setFocus,
    setValue,
    formState: { errors },
  } = useForm<EditDisplayNamePayload>({
    mode: "onChange",
  });

  useEffect(() => {
    if (data) {
      setFocus("label");
      setDisplayName(data?.label);
    }
  }, [data]);

  const handleSubmitDisplayNameChanges = form => {
    const { label } = form;
    const submission = {
      label: cleanProcessName(label),
    };
    onSubmit(submission);
  };

  return (
    <form
      className="flex h-full w-[600px] flex-col divide-gray-200 bg-white"
      onSubmit={e => {
        e.preventDefault();
        void handleSubmit(handleSubmitDisplayNameChanges)(e);
      }}>
      <div className="h-0 flex-1 overflow-y-auto">
        <div className="modal-header">
          <h3 className="text-lg font-medium leading-6 text-gray-900">
            Edit Display Name
          </h3>
          <p className="mt-1 text-xs leading-6 text-gray-500">
            This is the name that will appear in associated reports and
            applications that are generated
          </p>
        </div>
      </div>
      <div className="modal-body pb-4">
        <div className="flex flex-1 flex-col justify-between">
          <div className="my-6 flex flex-row items-center">
            <label className="flex w-64 flex-row items-center text-sm font-medium leading-6 text-gray-900">
              Display Name
              <span className="pl-1 text-red-400">*</span>
            </label>
            <div className="mt-2 w-full">
              <input
                {...register("label", displayNameOptions.label)}
                type="text"
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                autoFocus
                onBlur={e => {
                  let value = e.target.value;
                  value = cleanProcessName(value) as string;
                  setValue("label", value);
                }}
                defaultValue={displayName}
              />
              {errors.label && (
                <span className="text-xs text-rose-500">
                  {errors.label.message}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer flex justify-end space-x-2">
        <button
          type="button"
          className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          onClick={() => onCancel()}>
          Cancel
        </button>
        <button
          type="submit"
          className="ml-4 inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
          Save
        </button>
      </div>
    </form>
  );
}
